import { render, staticRenderFns } from "./SocialButtonGroupSettings.vue?vue&type=template&id=703687a2&scoped=true&"
import script from "./SocialButtonGroupSettings.vue?vue&type=script&lang=js&"
export * from "./SocialButtonGroupSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "703687a2",
  null
  
)

export default component.exports